import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core'
import { IlsModelService } from '../../services/ils-model.service'
import { Content } from '@monorepo/golab-generated'
import { NextlabWrapperComponent } from '../nextlab-wrapper/nextlab-wrapper.component'
import { IframeAppAndLabComponent } from '@monorepo/angular-common'

type AppLabType = 'twente' | 'iframe'

@Component({
  selector: 'app-app-and-lab',
  templateUrl: './app-and-lab.component.html',
  styleUrls: ['./app-and-lab.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NextlabWrapperComponent, IframeAppAndLabComponent],
})
export class AppAndLabComponent {
  readonly ilsModelService = inject(IlsModelService);

  appLabType: AppLabType = 'iframe'

  private _content: Content | undefined

  get content(): Content | undefined {
    return this._content
  }

  @Input() set content(content: Content | undefined) {
    this._content = content
    this.setAppLabType()
  }

  private setAppLabType() {
    if (this.ilsModelService.isTwenteApp(this.content)) {
      this.appLabType = 'twente'
    } else {
      this.appLabType = 'iframe'
    }
  }
}
